import { ArticleState, ArticleStateItem } from '@/lib/types/store/articles'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: ArticleState = {
  items: [],
  loading: false,
  error: null,
  selectedArticle: null,
  page: 1,
  limit: 10,
  total: 0,
  filterParams: null
}

const articlesSlice = createSlice({
  name: 'articles',
  initialState,
  reducers: {
    setArticles: (state, action: PayloadAction<ArticleStateItem[]>) => {
      state.items = action.payload
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedArticle: (state, action: PayloadAction<ArticleStateItem | null>) => {
      state.selectedArticle = action.payload
    },
    setPagination: (state, action: PayloadAction<{ page: number; limit: number; total: number }>) => {
      state.page = action.payload.page
      state.limit = action.payload.limit
      state.total = action.payload.total
    },
    setFilterParams: (state, action: PayloadAction<Record<string, unknown> | null>) => {
      state.filterParams = action.payload
    }
  },
})

export const {
  setArticles,
  setLoading,
  setError,
  setSelectedArticle,
  setPagination,
  setFilterParams
} = articlesSlice.actions

export default articlesSlice.reducer
